import { paginationCalculator } from "pagination-calculator";

export const createHeaders = () => {
    return [
                    
        {
            name: 'Location',
            field: 'locationName',
            type: 'text',
            sort: true,
            filter: true,
            minWidth: 250
        },        
        {
           
            name: 'Map',
            type: 'icon',
            filter: false,
            sort: false
        },
        
        
    ]
}


export const createPageData = (page, pageSize, totalPages) => {
    if (page === 1) {
        return {
            from: page,
            to: pageSize,
            total: totalPages,
            totalPages: Math.ceil(totalPages / pageSize),
            currentPage: page,
            pageSize: pageSize
        }
    } else {
        const pageData = paginationCalculator({
            total: totalPages,
            current: page,
            pageSize: pageSize
        });
        return {
            from: pageData.showingStart,
            to: pageData.showingEnd,
            total: totalPages,
            totalPages: Math.ceil(totalPages / pageSize),
            currentPage: page,
            pageSize: pageSize
        }
    }
}
